function easeInOut(currentTime, start, change, duration) {
  currentTime /= duration / 2;
  if (currentTime < 1)
    return change / 2 * currentTime * currentTime + start;

  currentTime -= 1;
  return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
}

function scrollTo(element, to, duration) {
  const start = element.scrollTop;
  const change = to - start;
  const increment = 20;

  const animateScroll = (elapsedTime) => {
    elapsedTime += increment;
    const position = easeInOut(elapsedTime, start, change, duration);
    element.scrollTop = position;
    if (elapsedTime < duration) {
      setTimeout(() => {
        animateScroll(elapsedTime);
      }, increment);
    }
  };

  animateScroll(0);
}

function windowScrollTo(to, duration) {
  const start = window.scrollY;
  const change = to - start;
  const increment = 20;

  const animateScroll = (elapsedTime) => {
    elapsedTime += increment;
    const position = easeInOut(elapsedTime, start, change, duration);
    window.scrollTo(0, position);
    if (elapsedTime < duration) {
      setTimeout(() => {
        animateScroll(elapsedTime);
      }, increment);
    }
  };

  animateScroll(0);
}

export { scrollTo, windowScrollTo };



// WEBPACK FOOTER //
// ./src/utils/animation.js